var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ContentNode } from './content-node';
import { EntityItems } from './entity-items';
import { SliceManageConnectionsTout } from './slice-manage-connectons-tout';
var cls = classNames('slice-connections-body');
export var SliceConnectionsBodyDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n  "])), theme.UNIT(4), theme.UNIT(1))
});
var IntroStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 300;\n  "], ["\n    font-weight: 300;\n  "])))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OutroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 300;\n  "], ["\n    font-weight: 300;\n  "])))
});
var ToutStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceConnectionsBody',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Intro: styled(ContentNode)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(ContentNode)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Items: styled(EntityItems)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Outro: styled(ContentNode)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Tout: styled(SliceManageConnectionsTout)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ToutStyles)
};
export var SliceConnectionsBody = function (props) {
  var componentProps = useComponentProps(My.NAME, SliceConnectionsBodyDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    defn = componentProps.defn,
    rest = __rest(componentProps, ["className", "children", "defn"]);
  var shouldRender = defn.shouldRender,
    canEdit = defn.canEdit,
    entity = defn.entity,
    hasContent = defn.hasContent,
    hasIntro = defn.hasIntro,
    hasOutro = defn.hasOutro,
    items = defn.items,
    variant = defn.variant;
  var intro = entity.intro,
    content = entity.content,
    outro = entity.outro;
  if (!shouldRender) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasIntro && React.createElement(My.Intro, {
    entity: intro
  }), hasContent && React.createElement(My.Content, {
    entity: content
  }), !!items.length ? React.createElement(My.Items, __assign({
    items: items
  }, rest, {
    disableLinks: canEdit,
    variant: variant
  })) : canEdit && React.createElement(My.Tout, {
    entity: entity
  }), hasOutro && React.createElement(My.Outro, {
    entity: outro
  }));
};
SliceConnectionsBody.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;